<template>
    <div class="sub-nav-flyout" :class="rootClasses">
        <transition name="trs-simple-appear">
            <div class="sub-nav-flyout--outer" v-if="hasContent">
                <div class="sub-nav-flyout--inner" :class="flyoutClasses">
                    <component :is="flyoutComponent"
                            :facet="'level-' + level"
                            :item="item"
                            :level="level"
                            :is-fixed="isFixed">
                    </component>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import navItemMixin from 'vue/mixins/nav-item';


    export default {
        mixins: [navItemMixin],
        props: {
            level: {
                type: Number,
            },
            isFixed: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            item() {
                return this.navigation[this.level].item;
            },
            flyout() {
                return this.item.flyout;
            },
            children() {
                return this.item.children;
            },
            hasChildren() {
                return (Array.isArray(this.children) && this.children.length);
            },
            hasContent() {
                return this.flyout || this.hasChildren;
            },
            rootClasses() {
                return [
                    this.flyout ? 'sub-nav-flyout__has-flyout' : '',
                    this.hasChildren ? 'sub-nav-flyout__has-children' : '',
                    `sub-nav-flyout__level-${ this.level }`,
                ];
            },
            flyoutClasses() {
                return [
                    (this.hasContent && this.item.color) ? `sub-nav-flyout--inner__col-${ this.item.color }` : '',
                    this.hasContent ? 'sub-nav-flyout--inner__col' : '',
                ];
            },
            flyoutComponent() {
                let result;

                if (this.flyout) {
                    result = 'cmp-flyout-data';
                }

                if (this.hasChildren) {
                    result = 'cmp-flyout-list';
                }

                return result;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?400608d4